<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
 import moment from 'moment'

 export default {
   name: 'OccasionsSliderTile',
   props: {
     sliderOccasions: Array,
     smCols: {
       type: Number,
       default: 12,
     },
     classes: String,
     showAllButton: Boolean,
   },
   methods: {
     getFormattedDate(date, type, isBirthYearVisible) {
       const dateFormat = type === 'birthday' && !isBirthYearVisible ? 'Do MMMM' : 'Do MMMM YYYY'
       return moment(date).format(dateFormat)
     },
   },
 }
</script>
